export default class Share {
  constructor(block) {
    this.block = block;

    this.block.addEventListener("click", this.onClick);
    this.block
      .querySelectorAll(".share_link a")
      .forEach(link =>
        link.addEventListener("click", this.onSocialButtonClicked)
      );
    this.open = false;
  }

  onClick = e => {
    e.preventDefault();
    if (!this.open) {
      this.block.classList.add("open");
    } else {
      this.block.classList.remove("open");
    }
    this.open = !this.open;
  };

  onSocialButtonClicked = e => {
    e.stopPropagation();
    e.preventDefault();
    const a = e.currentTarget;
    const url = a.getAttribute("href");
    const opts = `status=1,width=575,height=400,top=${(window.clientHeight -
      400) /
      2},left=${(window.clientWidth - 575) / 2}`;
    window.open(url, a.dataset.social, opts);
  };
}
